document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.product_variant_sb-flavours-wrapper');

    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const variants = wrapper.querySelectorAll('.product-grouping li');

        if (!variants.length) {
            return;
        }

        const currentProductHandle = wrapper.dataset.currentProductHandle || '';

        variants.forEach((variant) => {
            const link = variant.querySelector('a');
            const href = link?.getAttribute('href');

            if (href && currentProductHandle && href.includes(currentProductHandle)) {
                variant.classList.add('selected');
            }

            variant.addEventListener('click', () => {
                variants.forEach((item) => item.classList.remove('selected'));
                variant.classList.add('selected');
            });
        });
    });
});

